import {Dictionary} from '@malt/types-utils';
import {parseUrlParams} from './UrlService';

export function getHttpHeaders(): Dictionary {
    const headers: Dictionary<any> = {};
    const queryParams: Dictionary<string> = parseUrlParams(window.location.search);
    if (queryParams.immersion) {
        headers['X-Immersion-Identity'] = queryParams.immersion;
    }
    if (queryParams.identityId) {
        headers['X-Immersion-Identity'] = queryParams.identityId;
    }
    if (!headers['X-Immersion-Identity'] && document && document.getElementsByClassName('immersion-frame').length > 0) {
        headers['X-Immersion-Identity'] = 'default';
    }

    return headers;
}
